import '../../css/layout/side.css';
import { Link, Outlet, useOutlet } from 'react-router-dom';
import { useApp } from '../../hooks/AppProvider';
import { useState } from 'react';

const USER_ROAD_MAP = {
    "Accueil": "/",
    "Élèves": "app/student",
    "Jeux": {
        "Attribuer": "app/game/assign",
        "Général": "app/game/view",
        "Classe": "app/game/myview"
    },
    "Rôles": "app/role",
    "Comportement": {
        "Groupes": "app/behavior/groups",
        "Points": "app/behavior/points"
    }
}

const ADMIN_ROAD_MAP = {
    "Accueil": "/",
    "Enseignants": "admin/users",
    "Élèves": "admin/students",
    "Jeux": "admin/games"
}

function getPrivilegeName(tokenPayload) {
    switch(tokenPayload.level) {
        case 5:
            return "Utilisateur";
        case 10:
            return "Administrateur";
    }
}

function getRoadMap(level) {
    switch(level) {
        case 5:
            return USER_ROAD_MAP;
        case 10:
            return ADMIN_ROAD_MAP;
        default:
            return {};
    }
}

function DefaultTemplateSideElements() {
    let app = useApp();

    if(!app.isLogin()) {
        return <></>;
    }

    return (
        <>
            <div className='side'>
                <div className='side-top'>
                    <img className='profile-img' src='/img/profile.png' />
                    <div className='profile-text'>
                        <span><strong>{app.tokenPayload().display_name}</strong></span>
                        <span className='privilege-text'>{getPrivilegeName(app.tokenPayload())}</span>
                    </div>
                </div>
                <SideList map={getRoadMap(app.getPrivilegeLevel())} />
            </div>            
        </>
    );
}

function SideList({ map, parentKey = '' }) {
    return (
        <div className='sidebar-roadmap'>
            <ul>
                {Object.entries(map).map(([key, value]) => {
                    if (typeof value === "object") {
                        return <CollapsibleCategory key={parentKey + key} label={key} map={value} uniqueKey={parentKey + key} />
                    } else {
                        return <li key={parentKey + key}><Link to={value}>{key}</Link></li>
                    }
                })}
            </ul>
        </div>
    );
}

function CollapsibleCategory({ label, map, uniqueKey }) {
    const [open, setOpen] = useState(false);
    return (
        <li className={open ? 'open' : ''}>
            <span 
                style={{cursor:'pointer', userSelect:'none', width: '100%'}} 
                onClick={() => setOpen(o => !o)}
            >
                <span>{label}</span>
                <span style={{display: 'inline-flex', alignItems: 'center', minWidth: '1.5em', justifyContent: 'center'}}>
                    {open ? '▼' : '▶'}
                </span>
            </span>
            {open && <SideList map={map} parentKey={uniqueKey + '-'} />}
        </li>
    );
}

function Side({ children, show }) {

    return (
        <>
            <div className='body-layout'>
                {show && <DefaultTemplateSideElements />}
                <div className='main'>
                    {children}
                </div>
            </div>
        </>
    )
}

export { Side, DefaultTemplateSideElements }